import React from "react";
import moment from "moment";
import {
  englishToNepaliConverter,
  englishToNepaliAmountConverter,
  fixedValue,
} from "../../utils/services";
import { currentDateTime } from "../../utils/utils";
import { billDetailsResponse } from "./Receipt";
import { ReportType } from "../../EnumValues";
import { convertToNepaliWords } from "../../utils/num-to-nepaliwords";

interface TaxInvoiceProps {
  title: string;
  invoiceRef?: React.RefObject<HTMLDivElement>;
  businessInfo: any;
  userInfo: any;
  customerInfo: any;
  billDetails: any;
  amountDetails: any;
  paymentType: any;
  bankDetails?: any;
  reportType?: ReportType;
  isNepali?: boolean;
  langData: any;
  toWords: any;
  showFreeData: (billArray: billDetailsResponse[]) => boolean;
  billProductNumber?: string;
}

const TaxInvoiceA: React.FC<TaxInvoiceProps> = ({
  title,
  invoiceRef,
  businessInfo,
  userInfo,
  customerInfo,
  billDetails,
  amountDetails,
  paymentType,
  bankDetails,
  reportType = ReportType.Sales,
  isNepali = false,
  langData,
  toWords,
  showFreeData,
  billProductNumber = "28",
}) => {
  return (
    <div
      className={`receipt-section ${isNepali && "nepali-text"}`}
      ref={invoiceRef}
    >
      <div className="p-receipt">
        <div className="d-space-between">
          <div className="logo-detail">
            {reportType === ReportType.Sales && (
              <>
                <div className="d-flex logo-section">
                  {businessInfo?.logo ? (
                    <div className="logo">
                      <img src={businessInfo?.logo} alt="logo" />
                    </div>
                  ) : (
                    <div className="large-title">
                      {businessInfo?.name.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div>
                  <h2 className="small-title">{businessInfo?.name}</h2>
                  <p className="content">{businessInfo?.address}</p>

                  <div className="div-flex">
                    {businessInfo?.mobile_no && (
                      <div className="bold-content">
                        {langData.customerDetails.phone}:{" "}
                        <span className="content">
                          {englishToNepaliConverter(
                            String(`+977-${businessInfo?.mobile_no}`),
                          )}
                        </span>
                      </div>
                    )}
                    {businessInfo?.pan && (
                      <div className="bold-content pan-box">
                        {langData.customerDetails.panNo}:
                        <span className="content">
                          {englishToNepaliConverter(String(businessInfo?.pan))}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="receipt-detail-block d-end">
            {Number(userInfo?.bill_print_count) > 0 &&
            reportType === ReportType.Sales ? (
              <>
                <div className="content copy-text">
                  Copy of Original ({Number(userInfo?.bill_print_count)})
                </div>
              </>
            ) : (
              ""
            )}
            {reportType === ReportType.Sales && (
              <h2 className="large-title">{title} </h2>
            )}
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <th className="bold-content" scope="row">
                    {langData.billDetails.invoiceNo}:
                  </th>
                  <td className="content">
                    {reportType === ReportType.Purchase
                      ? userInfo?.bill_no
                      : userInfo?.document_no}
                  </td>
                </tr>
                {userInfo?.bill_miti && (
                  <tr>
                    <th className="bold-content" scope="row">
                      {langData.billDetails.billMiti}:
                    </th>

                    <td>
                      <span className="content">
                        {englishToNepaliConverter(
                          String(userInfo?.bill_miti.split("/").join(" - ")),
                        )}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div
          className={
            reportType === ReportType.Sales
              ? "d-space-between header-wrapper"
              : "d-space-between"
          }
        >
          <div className="receipt-header">
            <div className="receipt-header-block">
              <table className="table table-borderless">
                <tbody>
                  <tr>
                    <th className="bold-content" scope="row">
                      {langData.customerDetails.customerName}:
                    </th>
                    <td className="content">{customerInfo?.name}</td>
                  </tr>
                  {customerInfo?.additional_info?.address ||
                  customerInfo?.additional_info?.additionalProp1 ? (
                    <tr>
                      <th className="bold-content" scope="row">
                        {langData.customerDetails.address}:
                      </th>
                      <td className="content">
                        {customerInfo?.additional_info?.address ||
                          customerInfo?.additional_info?.additionalProp1}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}

                  <tr>
                    <th className="bold-content" scope="row">
                      {langData.customerDetails.phone}:
                    </th>

                    <td className="content">
                      {customerInfo?.mobile_no &&
                      customerInfo?.mobile_no !== 9841000000
                        ? englishToNepaliConverter(
                            String(`+977-${customerInfo?.mobile_no}`),
                          )
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th className="bold-content" scope="row">
                      {langData.customerDetails.panNo}:
                    </th>
                    <td className="content">
                      {customerInfo?.pan
                        ? englishToNepaliConverter(String(customerInfo?.pan))
                        : "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="last-block">
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <th className="bold-content" scope="row">
                    {langData.billDetails.transactionDate}:
                  </th>
                  <td className="content">
                    {englishToNepaliConverter(
                      String(userInfo?.bill_miti_ad.split("/").join(" - ")),
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="bold-content" scope="row">
                    {langData.billDetails.printDateTime}:
                  </th>
                  <td className="content">
                    {englishToNepaliConverter(String(currentDateTime()))}
                  </td>
                </tr>
                <tr>
                  <th className="bold-content" scope="row">
                    {langData.billDetails.IssuedBy}:{" "}
                  </th>
                  <td className="content">{userInfo?.name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="full-table">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th rowSpan={2} className="header-align-center sn-head">
                  {langData.productHeads.SN}
                </th>
                <th rowSpan={2} className="header-align-center name-sec">
                  {langData.productHeads.hsCode}
                </th>
                <th rowSpan={2} className="header-align-center name-sec">
                  {langData.productHeads.productName}
                </th>

                <th colSpan={2} className="center-align">
                  {langData.productHeads.quantity}
                </th>

                {showFreeData(billDetails as billDetailsResponse[]) && (
                  <th colSpan={2} className="center-align">
                    Free
                  </th>
                )}

                <th colSpan={2} className="center-align">
                  {langData.productHeads.rate}
                </th>

                <th rowSpan={2} className="end-align header-align-center">
                  {langData.productHeads.discount}
                </th>
                <th rowSpan={2} className="end-align header-align-center">
                  {langData.productHeads.tax}
                </th>
                <th rowSpan={2} className="end-align header-align-center">
                  {langData.productHeads.amount}
                </th>
              </tr>
              <tr className="center-align">
                <th>{langData.productHeads.pri}</th>
                <th>{langData.productHeads.sec}</th>
                {showFreeData(billDetails as billDetailsResponse[]) && (
                  <>
                    <th>Pri</th>
                    <th>SEC</th>
                  </>
                )}

                <th>{langData.productHeads.pri}</th>
                <th>{langData.productHeads.sec}</th>
              </tr>
            </thead>
            <tbody>
              {billDetails &&
                Array(Number(billProductNumber))
                  .fill(undefined)
                  ?.map((_, index) => {
                    const item = billDetails[index];
                    return (
                      <tr
                        style={{ visibility: item ? "visible" : "hidden" }}
                        key={index}
                      >
                        <td className="padd-5"> {item ? index + 1 : "1"}</td>
                        <td></td>
                        <td className="padd-5 name-sec">{item?.product}</td>
                        <td className="padd-5">
                          <p>
                            {item?.primary_unit > 0
                              ? englishToNepaliConverter(
                                  String(item?.primary_unit) +
                                    " " +
                                    item?.primary_unit_measure,
                                )
                              : "-"}
                          </p>
                        </td>
                        <td className="padd-5">
                          <p>
                            {item?.secondary_unit > 0
                              ? englishToNepaliConverter(
                                  String(item?.secondary_unit),
                                ) +
                                " " +
                                item?.secondary_unit_measure
                              : "-"}
                          </p>
                        </td>
                        {showFreeData(billDetails as billDetailsResponse[]) && (
                          <>
                            <td className="padd-5">
                              <p>
                                {englishToNepaliConverter(
                                  String(item?.free_primary_unit),
                                )}
                              </p>
                            </td>
                            <td className="padd-5">
                              <p>
                                {englishToNepaliConverter(
                                  String(item?.free_secondary_unit),
                                )}
                              </p>
                            </td>
                          </>
                        )}

                        <td className="padd-5">
                          <p>
                            {item?.primary_unit > 0
                              ? englishToNepaliAmountConverter(
                                  String(item?.primary_price),
                                )
                              : "-"}
                          </p>
                        </td>
                        <td className="padd-5">
                          <p>
                            {item?.secondary_unit > 0
                              ? englishToNepaliAmountConverter(
                                  String(item?.secondary_price),
                                )
                              : "-"}
                          </p>
                        </td>

                        <td className="padd-5 end-col">
                          {!userInfo?.is_total_discount
                            ? englishToNepaliAmountConverter(
                                String(item?.discount),
                              )
                            : englishToNepaliAmountConverter(0)}
                        </td>
                        <td className="padd-5 end-col">
                          {englishToNepaliAmountConverter(
                            String(item?.tax > 0 ? "13" : "0"),
                          )}
                          %
                        </td>
                        <td className="padd-5 end-col">
                          <p>
                            {englishToNepaliAmountConverter(
                              String(item?.sub_total),
                            )}
                          </p>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </table>
        </div>
        <div className="footer-div">
          <div className="receipt-info">
            <div className="receipt-info-section">
              <div className="receipt-info-block">
                <h4 className="block-title">
                  {langData.transactionDetails.inWords}:
                </h4>
                <p className="small-content capitalize">
                  {isNepali
                    ? convertToNepaliWords(
                        fixedValue(amountDetails?.total_amount, 2) || 0,
                      )
                    : toWords.convert(
                        fixedValue(amountDetails?.total_amount, 2) || 0,
                      )}
                </p>
              </div>
            </div>
            <div className="receipt-info-section ">
              <div className="receipt-info-block">
                <h4 className="block-title capitalize">
                  {langData.footer.note}:
                </h4>
                <p className="small-content">
                  {userInfo?.customer_notes || `Thank You`}
                </p>
              </div>
            </div>
            <div className="receipt-info-block">
              <h4 className="block-title">
                {langData.signatures.authorized} :
              </h4>
              <p className="small-content customers-sign">
                ----------------------------
              </p>
            </div>
          </div>

          <div className="receipt-calculation">
            <div className="receipt-calculation-block">
              <p className="small-content">
                {langData.transactionDetails.subTotal}
              </p>
              <p className="small-content text-right">
                {langData.transactionDetails.rupees}.{" "}
                {englishToNepaliAmountConverter(
                  String(amountDetails?.sub_total),
                  2,
                )}
              </p>
            </div>
            <div className="receipt-calculation-block">
              <p className="small-content">
                {langData.transactionDetails.discount}
              </p>
              <p className="small-content text-right">
                {langData.transactionDetails.rupees}.{" "}
                {amountDetails && amountDetails?.discount_paid > 0
                  ? englishToNepaliAmountConverter(
                      String(amountDetails?.discount_paid),
                      2,
                    )
                  : englishToNepaliAmountConverter(
                      String(amountDetails?.discount_received),
                      2,
                    )}
              </p>
            </div>
            <div className="receipt-calculation-block">
              <p className="bold-content">
                {langData.transactionDetails.taxableAmt}
              </p>
              <p className="small-content text-right">
                {langData.transactionDetails.rupees}.{" "}
                {amountDetails &&
                  englishToNepaliAmountConverter(
                    String(amountDetails?.taxable_amount),
                    2,
                  )}
              </p>
            </div>
            <div className="receipt-calculation-block">
              <p className="small-content">
                {langData.transactionDetails.vat} @{" "}
                {langData.transactionDetails.vatPer}%{" "}
              </p>
              <p className="small-content text-right">
                {langData.transactionDetails.rupees}.{" "}
                {amountDetails && amountDetails?.tax_paid > 0
                  ? englishToNepaliAmountConverter(
                      String(amountDetails?.tax_paid),
                      2,
                    )
                  : englishToNepaliAmountConverter(
                      String(amountDetails?.tax_received),
                      2,
                    )}
              </p>
            </div>
            <div className="receipt-calculation-block">
              <p className="bold-content">
                {langData.transactionDetails.total} (
                {langData.transactionDetails.npr})
              </p>
              <p className="content text-right">
                {langData.transactionDetails.rupees}.{" "}
                {englishToNepaliAmountConverter(
                  String(amountDetails?.total_amount),
                  2,
                )}
              </p>
            </div>
            <div className="receipt-info-block width-21">
              <h4 className="block-title text-right">
                {langData.signatures.customer}:
              </h4>
              <p className="small-content customers-sign text-right">
                ----------------------------
              </p>
            </div>
          </div>
        </div>

        {(bankDetails?.length || 0) > 0 && (
          <div className="receipt-info payment-information">
            <div className="receipt-info-block ">
              <h4 className="block-title">Payment Information</h4>
              {bankDetails?.map((bank: any) => {
                return (
                  <>
                    <p className="small-content">Bank Name: {bank.bank_name}</p>
                    <p className="small-content">
                      Cheque No.: {bank.cheque_no}
                    </p>
                    <p className="small-content">
                      Cheque Issued Date:{" "}
                      {moment(bank?.issue_date).format("YYYY - MM - DD")}
                    </p>
                    <p className="small-content">Amount: Rs. {bank.amount}</p>
                  </>
                );
              })}
            </div>
          </div>
        )}
        <div className="receipt-info">
          <div className="receipt-info-block receipt-footer">
            <p className="small-content">{langData.footer.computerGenerated}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxInvoiceA;
